export interface GallerySlide {
  src: string
  alt: string
  title: string
  caption: string
}

const IMG_BASE =
  'https://sb.impultienda.ar/storage/v1/object/public/ebook-images/ce375233-897d-4539-a6cb-1fdc37e0b6d7/product-uploads/'

export const insideItems: string[] = [
  'The welding circuit & arc basics',
  'AC, DCEP & DCEN polarity',
  'CC vs. CV power sources',
  'PPE & lens shade selection',
  'Fume, fire & cylinder safety',
  'Metal properties & identification',
  'Distortion control',
  'Joint types & parts of a weld',
  'Welding positions',
  'Cleaning, grinding & beveling',
  'Fit-up & tack welding',
  'MIG setup & wire feeding',
  'Shielding gases & flow rates',
  'Starting settings charts',
  'Gun angles: push vs. drag',
  'Tungsten selection & grinding',
  'Torch & filler rod angles',
  'Stainless & aluminum TIG',
  'Electrode classifications',
  'Stick amperage ranges',
  'Open root with E6010',
  'Reading prints & drawings',
  'AWS A2.4 welding symbols',
  'WPS, PQR & WPQ',
  'Visual inspection & fillet gauges',
  'Discontinuities & NDT basics',
  'Bend test coupons',
  'Lesson plans & demonstrations',
  '❌/✅ comparisons',
  'Teaching cues, drills & quick checks',
]

/** Carousel slides — one real page per volume (Vol 1 to Vol 6). */
export const gallerySlides: GallerySlide[] = [
  {
    src: `${IMG_BASE}mcp_be0e6a9b-d609-47e7-80db-774208b012e5_1793859550389.jpg`,
    alt: 'Welding Instructor Atlas — Vol 1 page: Parts of a Weld, labeled fillet and groove cross-sections',
    title: 'Vol 1 — Parts of a Weld',
    caption: 'Vol 1 — Welding Fundamentals, Safety, Equipment & Metal Preparation: labeled fillet and groove cross-sections, a throat calculation, an instructor cue and a drill.',
  },
  {
    src: `${IMG_BASE}mcp_be0e6a9b-d609-47e7-80db-774208b012e5_1793859552933.jpg`,
    alt: 'Welding Instructor Atlas — Vol 2 page: Gun Angles, push vs. drag with travel direction and bead profiles',
    title: 'Vol 2 — Gun Angles: Push vs. Drag',
    caption: 'Vol 2 — MIG/MAG Welding, GMAW Techniques & Practical Applications: push and drag angles side by side, bead profiles, a memory aid and a drill.',
  },
  {
    src: `${IMG_BASE}mcp_be0e6a9b-d609-47e7-80db-774208b012e5_1793859555808.jpg`,
    alt: 'Welding Instructor Atlas — Vol 3 page: Torch & Filler Rod Angles, TIG torch angle, filler angle and arc length',
    title: 'Vol 3 — Torch & Filler Rod Angles',
    caption: 'Vol 3 — TIG Welding, GTAW Techniques & Precision Fabrication: torch angle, filler rod angle and arc length explained, an instructor cue and a quick check.',
  },
  {
    src: `${IMG_BASE}mcp_be0e6a9b-d609-47e7-80db-774208b012e5_1793859558658.jpg`,
    alt: 'Welding Instructor Atlas — Vol 4 page: Electrode Angles, travel (drag) angle and work angle by joint type',
    title: 'Vol 4 — Electrode Angles',
    caption: 'Vol 4 — Stick Welding, SMAW Processes & Structural Welding: travel and work angles by joint type, common mistakes, an instructor cue and a 15-minute drill.',
  },
  {
    src: `${IMG_BASE}mcp_be0e6a9b-d609-47e7-80db-774208b012e5_1793859561473.jpg`,
    alt: 'Welding Instructor Atlas — Vol 5 page: Fillet Weld Symbol, key AWS A2.4 rules with continuous and intermittent examples',
    title: 'Vol 5 — Fillet Weld Symbol',
    caption: 'Vol 5 — Welding Blueprints, Symbols, Inspection & Quality Control: AWS A2.4 fillet symbol rules, ❌/✅, size, length and pitch examples and a drill.',
  },
  {
    src: `${IMG_BASE}mcp_be0e6a9b-d609-47e7-80db-774208b012e5_1793859564052.jpg`,
    alt: 'Welding Instructor Atlas — Vol 6 page: Skill Progression Ladder, seven rungs with entry criteria at each level',
    title: 'Vol 6 — Skill Progression Ladder',
    caption: 'Vol 6 — Welding Instruction, Workshop Training & Practical Assessments: seven skill rungs from flat stringers to pipe, entry criteria and an instructor cue.',
  },
]
